import React, { useMemo } from "react";

export default function ListMenu({ userType }) {
  // 🧠 Dynamically build the columns based on userType
  const columns = useMemo(() => {
    const baseColumns = [
      "Master",
      "Booked",
      "Live P&L",
      "Net P&L",
      "Admin Sharing",
      "Super Sharing",
      "Master Sharing",
      "Admin Live P&L",
      "Super Live P&L",
      "Master Live P&L",
    ];

    return userType === 1 ? ["Super", ...baseColumns] : baseColumns;
  }, [userType]);

  return (
    <div className="menuContainer primary white">
      {columns.map((col, index) => {
        const isSharingOrLive =
          col.toLowerCase().includes("sharing") ||
          col.toLowerCase().includes("live");

        return (
          <div
            key={index}
            className={`${isSharingOrLive ? "menuName" : "menuUsername"} ${
              userType === 1 ? "small" : ""
            }`}
          >
            {col}
          </div>
        );
      })}
    </div>
  );
}
